<template>
	<v-container>
		<v-row>
			<v-col cols="12" md="6">
				<v-card outlined>
					<v-card-title>Создание заявки</v-card-title>
					<v-form
						ref="form"
						@submit.stop.prevent="submit"
					>
						<v-stepper v-model="step">
							<v-stepper-step
								step="1"
								:complete="completedStep1"
								:editable="completedStep1"
							>
								<template v-if="completedStep1">
									<div>
										Контрагент: <b>{{ form.client.name }}</b>
									</div>
								</template>
								<template v-else>
									Контрагент
								</template>
							</v-stepper-step>

							<v-stepper-content
								step="1"
								class="py-0"
							>
								<v-row>
									<v-col cols="12">
										<v-autocomplete
											v-model="form.client"
											:search-input.sync="autocompletes.client.term"
											:items="autocompletes.client.items"
											:readonly="!!form.client"
											label="Контрагент"
											item-text="name"
											item-value="id"
											autocomplete="off"
											return-object
											outlined
											dense
											clearable
										/>
									</v-col>
									<v-col cols="12" class="pt-0">
										<v-btn
											:disabled="!completedStep1"
											color="primary"
											@click="step++"
											v-text="'Далее'"
										/>
									</v-col>
								</v-row>
							</v-stepper-content>

							<v-stepper-step
								step="2"
								:complete="completedStep2"
								:editable="completedStep2"
							>
								Данные заявки
							</v-stepper-step>

							<v-stepper-content
								step="2"
								class="py-0"
							>
								<v-row>
									<v-col cols="12">
										<v-autocomplete
											v-model="form.place"
											name="place_id"
											:search-input.sync="autocompletes.place.term"
											:items="autocompletes.place.items"
											:rules="[() => !!form.place || 'Выберите объект']"
											:filter="() => true"
											label="Объект"
											item-text="name"
											item-value="id"
											autocomplete="off"
											return-object
											outlined
											dense
										>
											<template #selection="{ item: place }">
												<span>{{ place.name }}. {{ place.city.name }}, {{
														place.address
													}}</span>
											</template>
											<template #item="{ item: place }">
												<v-list-item-content>
													<v-list-item-title>{{ place.name }}</v-list-item-title>
													<v-list-item-subtitle>
														{{ place.city.name }}, {{ place.address }}
													</v-list-item-subtitle>
												</v-list-item-content>
											</template>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" md="6">
										<v-autocomplete
											v-model="form.machine"
											name="machine"
											:search-input.sync="autocompletes.machine.term"
											:items="autocompletes.machine.items"
											:rules="[() => !!form.machine || 'Выберите технику']"
											label="Техника"
											item-text="name"
											item-value="id"
											autocomplete="off"
											return-object
											outlined
											dense
										>
											<template #item="{ item: machine, on }">
												<v-list-item v-on="on">
													<v-list-item-content>
														<v-list-item-title>
															<span class="blue--text">{{ machine.type }}</span>
															{{ machine.name }}
														</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
											</template>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="form.machine_engine_hours"
											label="Пробег"
											name="machine_engine_hours"
											outlined
											dense
										/>
									</v-col>
									<v-col cols="12">
										<v-textarea
											v-model="form.client_description"
											name="client_description"
											outlined
											dense
											label="Описание неисправности"
											:rules="[() => !!form.client_description || 'Заполните описание неисправности']"
										/>
									</v-col>
									<v-col cols="12" class="pb-0">
										<v-text-field
											v-model="form.contact_name"
											label="Контактное лицо"
											name="contact_name"
											:rules="[() => !!form.contact_name || 'Заполните контактное лицо']"
											outlined
											dense
										/>
									</v-col>
									<v-col cols="12" md="6" class="pt-0">
										<v-text-field
											v-model="form.contact_phone"
											label="Телефон"
											name="contact_phone"
											:rules="[() => !!form.contact_phone || 'Заполните телефон']"
											outlined
											dense
										/>
									</v-col>
									<v-col cols="12" md="6" class="pt-0">
										<v-text-field
											v-model="form.contact_email"
											label="Email"
											name="contact_email"
											:rules="[() => !!form.contact_email || 'Заполните Email']"
											outlined
											dense
										/>
									</v-col>

									<v-col cols="12">
										<v-btn
											:disabled="!completedStep2"
											color="green"
											type="submit"
											outlined
											v-text="'Сохранить'"
										/>
									</v-col>
								</v-row>
							</v-stepper-content>

						</v-stepper>
					</v-form>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

import axios from 'axios';

const EMPTY_FORM = () => ({
	client: null,
	place: null,
	machine: null,
	machine_engine_hours: null,
	contact_name: null,
	contact_phone: null,
	contact_email: null,
	client_description: null,
});

export default {
	name: 'RepairOrderCreate',
	data: () => ({
		loading: false,
		step: 1,
		form: EMPTY_FORM(),
		autocompletes: {
			client: {
				term: '',
				items: [],
			},
			machine: {
				term: '',
				items: [],
			},
			place: {
				term: '',
				items: [],
			},
		},
	}),
	computed: {
		completedStep1() {
			return !!this.form.client;
		},
		completedStep2() {
			return !!this.form.place
				&& !!this.form.client_description
				&& !!this.form.machine
				&& !!this.form.contact_email
				&& !!this.form.contact_name
				&& !!this.form.contact_phone;
		},
		mappedForm() {
			return {
				client_id: this.form.client?.id,
				place_id: this.form.place?.id,
				machine_id: this.form.machine?.id,
				machine_engine_hours: this.form.machine_engine_hours,
				contact_name: this.form.contact_name,
				contact_phone: this.form.contact_phone,
				contact_email: this.form.contact_email,
				client_description: this.form.client_description,
			};
		},
	},
	watch: {
		'autocompletes.client.term'(val) {
			this.searchClients(val);
		},
		'autocompletes.machine.term'(val) {
			this.searchMachines(val);
		},
		'autocompletes.place.term'(val) {
			this.searchPlaces(val);
		},
		'form.client'(val) {
			if (!!val) {
				this.searchPlaces('');
				this.searchMachines('');
			}
		},
	},
	mounted() {
		this.CancelToken = axios.CancelToken;
		this.sourceClients = this.CancelToken.source();
		this.sourceMachines = this.CancelToken.source();
		this.sourcePlaces = this.CancelToken.source();
	},
	methods: {
		async submit() {
			if (this.loading || !this.$refs.form.validate()) return;
			this.loading = true;
			try {
				const response = await this.$http.post(`/api/v2/service/orders/repair`, this.mappedForm);
				this.$notify('Заявка создана');
				await this.$router.push(`/orders/repair/${response.data.data.id}`);
			} catch (e) {
				this.$notify.error(e.message);
			} finally {
				this.loading = false;
			}
		},
		async searchClients(term) {
			try {
				this.sourceClients.cancel('Operation cancelled by user');
				this.sourceClients = this.CancelToken.source();
				const response = await this.$http.get('/api/v1/clients', {
					params: {
						filter: {
							search: term,
						},
					},
					cancelToken: this.sourceClients.token,
				});
				this.autocompletes.client.items = response.data.data;
			} catch (e) {
				console.error(e);
			}
		},
		async searchPlaces(term) {
			if (!this.form.client) return;
			try {
				this.sourcePlaces.cancel('Operation cancelled by user');
				this.sourcePlaces = this.CancelToken.source();
				const response = await this.$http.get(`/api/v2/service/clients/${this.form.client.id}/places`, {
					params: {
						filter: {
							search: term,
						},
					},
					cancelToken: this.sourcePlaces.token,
				});
				this.autocompletes.place.items = response.data.data;
			} catch (e) {
				console.error(e);
			}
		},
		async searchMachines(term) {
			if (!this.form.client) return;
			try {
				this.sourceMachines.cancel('Operation cancelled by user');
				this.sourceMachines = this.CancelToken.source();
				const response = await this.$http.get(`/api/v2/service/clients/${this.form.client.id}/machines`, {
					params: {
						filter: {
							search: term,
						},
					},
					cancelToken: this.sourceMachines.token,
				});
				this.autocompletes.machine.items = response.data.data;
			} catch (e) {
				console.error(e);
			}
		},
	},
};
</script>

<style scoped>

</style>
